import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileEvent } from '../../interfaces/util-types';
import { DialogService } from '../../shared/dialog.service';

const ACCEPTED_EVENT_POSTER_SIZE = 2 * 1024 * 1024;
const ACCEPTED_SUBSCRIPTION_POSTER_SIZE = 1024 * 1024;
const ACCEPTED_EVENT_POSTER_TYPE = ['image/png', 'image/jpeg'];
@Component({
  selector: 'app-events-tags-image',
  templateUrl: './events-tags-image.component.html',
  styleUrls: ['./events-tags-image.component.scss'],
})
export class EventsTagsImageComponent implements OnInit {
  posterCoverImage: string | null;
  imageLoaded = false;
  @ViewChild('image') image!: ElementRef;
  imageFile: File | undefined;
  tabType = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { imgUrl: string; type: string },
    private readonly dialogService: DialogService,
    private readonly dialogRef: MatDialogRef<EventsTagsImageComponent>,
  ) {
    this.posterCoverImage = data.imgUrl;
    this.tabType = data.type;
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed().subscribe(() =>
      this.dialogRef.close({
        imageUrl: this.posterCoverImage,
        imageFile: this.imageFile,
      }),
    );
  }

  onLoadImage() {
    this.imageLoaded = true;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDropSuccess(event: DragEvent, dragField: string) {
    event.preventDefault();
    const selectedFile = event.dataTransfer?.files;
    const target = {
      target: {
        files: selectedFile,
      },
    };
    this.imageHandler(selectedFile, target, dragField);
  }

  imageUpload(event: Event, dragField: string) {
    const selectedFile = (event.target as HTMLInputElement).files;
    this.imageHandler(selectedFile, event, dragField);
  }

  async imageHandler(selectedFile: FileList | null | undefined, event: FileEvent, dragField: string) {
    const file = selectedFile?.item(0);
    if (!file || (file.size > ACCEPTED_SUBSCRIPTION_POSTER_SIZE || !ACCEPTED_EVENT_POSTER_TYPE.includes(file.type)) && this.tabType === 'SUBSCRIPTION') {
      this.dialogRef.addPanelClass('hide-image-dialog');
      this.openError('1 MB');
      this.image.nativeElement.value = null;
      return;
    }
    if (
      !file ||
      file.size > ACCEPTED_EVENT_POSTER_SIZE ||
      !ACCEPTED_EVENT_POSTER_TYPE.includes(file.type)
    ) {
      this.dialogRef.addPanelClass('hide-image-dialog');
      this.openError('2 MB');
      this.image.nativeElement.value = null;
      return;
    }

    this.dialogRef.addPanelClass('hide-image-dialog');
    const fileType = file.type;
    const format = fileType.substring(
      fileType.indexOf('/') + 1,
      fileType.length,
    );
    const data = {
      cropEvent: event,
      format: format,
      aspectRatio: dragField === 'EVENT' ? 16 / 9 : 3 / 1,
    };

    const cropImage = this.dialogService.openImageCropperDialog(data);
    cropImage.afterClosed().subscribe((res) => {
      if (res.croppedImage) {
        this.dialogRef.removePanelClass('hide-image-dialog');
        this.posterCoverImage = res.croppedImage;
        this.imageFile = file;
        this.image.nativeElement.value = null;
      } else {
        this.dialogRef.removePanelClass('hide-image-dialog');
        this.image.nativeElement.value = null;
      }
    });
  }
  openError(size: string) {
    const message = '';
    const data = {
      fileSize: size,
      message: message,
      format: '.jpg, .png',
    };
    this.dialogService
      .openErrorDialog(data)
      .afterClosed()
      .subscribe(() => {
        this.dialogRef.removePanelClass('hide-image-dialog');
      });
  }
  removeImage() {
    this.posterCoverImage = null;
    this.imageFile = undefined;
  }
}
